import { createApp } from 'vue'
import App from './JustTransition.vue'

createApp(App).mount('#app-just-transition')
